// core version + navigation, pagination modules:
import Swiper from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
// import Swiper and modules styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

class FeaturedPropertiesSlideshowHandlerClass extends elementorModules.frontend
  .handlers.Base {
  getDefaultSettings() {
    return {
      selectors: {
        swiperEl: ".swiper",
        sliderPrevEl: `[data-ref="sliderPrev"]`,
        sliderNextEl: `[data-ref="sliderNext"]`,
      },
    };
  }

  getDefaultElements() {
    const selectors = this.getSettings("selectors");

    return {
      $swiperEl: this.$element.find(selectors.swiperEl),
      $sliderPrevEl: this.$element.find(selectors.sliderPrevEl),
      $sliderNextEl: this.$element.find(selectors.sliderNextEl),
    };
  }

  /**
   * On Init
   *
   * Runs when the widget is loaded and initialized in the frontend.
   */
  onInit() {
    //const widget = `div[data-id="${this.getID()}"] .swiper`;
    this.initSwiper();
  }

  initSwiper() {
    const { $swiperEl, $sliderPrevEl, $sliderNextEl } =
      this.getDefaultElements();

    const config = {
      modules: [Autoplay, Navigation, Pagination],
      roundLengths: true,
      autoplay: {
        delay: 4000,
        pauseOnMouseEnter: true,
        waitForTransition: true,
        stopOnLastSlide: false,
      },
      loop: true,
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 10,
        },
        // when window width is >= 768px
        768: {
          slidesPerView: 2,
          slidesPerGroup: 1,
          spaceBetween: 30,
        },
        // when window width is >= 1024px
        1024: {
          slidesPerView: 3,
          slidesPerGroup: 1,
          spaceBetween: 30,
        },
      },
      // If we need pagination
      /* pagination: {
        el: refs.sliderPropertiesPagination,
        clickable: true,
      }, */
      // Navigation arrows
      navigation: {
        prevEl: $sliderPrevEl[0],
        nextEl: $sliderNextEl[0],
      },
    };

    // init Swiper:
    const swiper = new Swiper($swiperEl[0], config);
  }
}

// init handler
/**
 * Registers the `widget-properties-featured-slideshow` element handler.
 *
 * The handler is responsible for initializing the Swiper slider.
 *
 * @param {jQuery} $ - jQuery object.
 */
(function ($) {
  $(window).on("elementor/frontend/init", () => {
    elementorFrontend.elementsHandler.attachHandler(
      "widget-properties-featured-slideshow",
      FeaturedPropertiesSlideshowHandlerClass
    );
  });
})(jQuery);
